<template>
  <div>
    <p>Understand the order and timing of message processing with sequence diagrams:</p>
    <ul>
      <li><strong>Timeline view</strong> - See messages arranged chronologically as they were processed</li>
      <li><strong>Endpoint interactions</strong> - Visualize how endpoints communicate with each other</li>
      <li><strong>Handler execution</strong> - Track which handlers processed each message</li>
    </ul>
  </div>
</template>
